import { useEffect } from "react";
import { Link } from "react-router-dom";
import { usePageTitle } from "@/lib/usePageTitle";
import { PageHero } from "@/components/site/ui";
import { useLocale } from "@/i18n/LocaleContext";

export default function NotFound() {
  usePageTitle("notFound");
  const { t, path } = useLocale();
  // Tell crawlers this is a soft 404 (the static host answers 200 for every path).
  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex";
    document.head.appendChild(meta);
    return () => meta.remove();
  }, []);
  return (
    <div data-testid="notfound-page">
      <PageHero title={t.notFound.title} subtitle={t.notFound.subtitle} />
      <section className="bg-white">
        <div className="max-w-3xl mx-auto px-5 md:px-10 py-16 md:py-20 text-lg text-muted-foreground leading-relaxed">
          <p>{t.notFound.text}</p>
          <p className="mt-6">
            <Link to={path("home")} className="font-600 text-brand underline underline-offset-4">
              {t.notFound.home}
            </Link>
          </p>
        </div>
      </section>
    </div>
  );
}
